import { action, Action } from 'easy-peasy';

const initialState = {
  email: '',
  registrationFormData: {
    email: '',
    lastName: '',
    firstName: '',
    birthDay: '',
  },
  featureFlags: [],
  featureFlagsLoaded: false,
};

export interface AuthStore {
  email: string;
  featureFlags: string[];
  featureFlagsLoaded: boolean;
  setFeatureFlag: Action<AuthStore, string[]>;
  setAuthEmail: Action<AuthStore, string>;
  reset: Action<AuthStore>;
}

export const authStore: AuthStore = {
  ...initialState,
  setFeatureFlag: action((state, payload) => {
    state.featureFlags = payload;
    state.featureFlagsLoaded = true;
  }),
  setAuthEmail: action((state, payload) => {
    // removing possible spaces from pone number input
    state.email = payload.replace(/\s/g, '');
  }),
  reset: action(() => ({
    ...initialState,
  })),
};
